import { render, staticRenderFns } from "./prestations-tarifs.html?vue&type=template&id=97f128cc&scoped=true&external"
import script from "./prestations-tarifs.js?vue&type=script&lang=js&external"
export * from "./prestations-tarifs.js?vue&type=script&lang=js&external"
import style0 from "./prestations-tarifs.scss?vue&type=style&index=0&id=97f128cc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f128cc",
  null
  
)

export default component.exports